import React from 'react';
import {useTranslation} from 'react-i18next';
import {UserInRegListType} from '../../types/TypesUserProfit';
import GridTableHead from '../../Components/GridTableHead/GridTableHead';
import TableRegistrationListRowEl from './TableRegistrationListRowEl';
import s from '../../Components/TableCommonDirectory/TableElements/TableElements.module.css';
import sLocal from './RegistrationNewClient.module.css';

type Props = {
	data: UserInRegListType[];
};

const GRID_TEMPLATE_COLUMNS = '1.5fr 1.5fr 1.5fr 2fr 1.5fr 1fr 1fr';

const TableRegistrationList: React.FC<Props> = ({data}) => {
	const {t} = useTranslation();
	return (
		<div className={s.tableScrollWrapper}>
			<div className={sLocal.registrationTableContainer}>
				<GridTableHead
					columns={[
						t('Дата'),
						t('Активован'),
						t('Контракт'),
						t("Ім'я"),
						t('Статус'),
						t('Спонсор'),
						t('Дії'),
					]}
					gridTemplateColumns={GRID_TEMPLATE_COLUMNS}
				/>
				{data.map((user) => (
					<TableRegistrationListRowEl
						key={user.user_id}
						user={user}
						gridTemplateColumns={GRID_TEMPLATE_COLUMNS}
					/>
				))}
			</div>
		</div>
	);
};

export default TableRegistrationList;
